import type {RefObject} from 'react'

type Ref = RefObject<HTMLElement>
type Behavior = 'smooth' | 'auto'

export const scrollIntoView = (elementRef: Ref, behavior: Behavior = 'auto') => {
    elementRef.current?.scrollIntoView({behavior, block: 'center', inline: 'center'})
}

export const scrollToTop = (elementRef?: Ref, behavior: Behavior = 'auto') => {
    const target = elementRef?.current || document.documentElement

    target.scrollTo({
        top: 0,
        behavior,
    })
}

export const scrollToBottom = (elementRef?: Ref, behavior: Behavior = 'auto') => {
    const target = elementRef?.current || document.documentElement

    target.scrollTo({
        top: target.scrollHeight,
        behavior,
    })
}
